export enum SavedReportTypes {
  unknown = 0,
  pdg = 1,
  tdg = 2,
  cdg = 3,
  adHoc = 4,
  tmj = 5,
  compare = 6,
  campaignTdg = 7,
  campaignCdg = 8,
  campaignTdgPpt = 9,
  bulkPdgArchive = 10,
  organisationCdg = 11,
  personalEdition = 12
}
